export default "__VITE_ASSET__CoM_FF$Y__"